import { render, staticRenderFns } from "./DuaMessageMiscFields.vue?vue&type=template&id=11923036"
import script from "./DuaMessageMiscFields.vue?vue&type=script&lang=js"
export * from "./DuaMessageMiscFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports